import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

import FeaturedCollectionProduct from "./FeaturedCollectionProduct";
import { getFeaturedProducts } from "../api/apiCalls";
import FeaturedProductSkeleton from "./skeleton-render/FeaturedProductSkeleton";

gsap.registerPlugin(ScrollTrigger);

function FeaturedCollection({
  sectionId,
  eyebrow,
  gear,
  description,
  results,
  featured,
}) {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const sectionRef = useRef(null);

  useEffect(() => {
    let isMounted = true;

    getFeaturedProducts(featured).then(
      (res) => {
        if (!isMounted) {
          return;
        }

        const sortedProducts = Array.isArray(res)
          ? res
              .slice()
              .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
              .slice(0, results || 8)
          : [];

        setProducts(sortedProducts);
        setLoading(false);
      },
      () => {
        if (!isMounted) {
          return;
        }

        setProducts([]);
        setLoading(false);
      }
    );

    return () => {
      isMounted = false;
    };
  }, [featured, results]);

  useLayoutEffect(() => {
    if (!sectionRef.current) {
      return undefined;
    }

    const ctx = gsap.context(() => {
      gsap.from(".featured__collection__heading", {
        y: 42,
        opacity: 0,
        duration: 0.9,
        ease: "power3.out",
        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top 82%",
        },
      });

      gsap.from(".featured__collection__singlep", {
        y: 32,
        opacity: 0,
        duration: 0.7,
        stagger: 0.08,
        ease: "power3.out",
        scrollTrigger: {
          trigger: ".featured__collection__products",
          start: "top 84%",
        },
      });
    }, sectionRef);

    return () => ctx.revert();
  }, [products]);

  return (
    <section
      className="featured__collection__container mgTop"
      ref={sectionRef}
      id={sectionId}
    >
      <div className="featured__collection__wrapper container">
        <div className="featured__collection__heading">
          {eyebrow ? <span className="featured__collection__eyebrow">{eyebrow}</span> : null}
          <h2 className="title__h2">{gear}</h2>
          {description ? <p className="featured__collection__description">{description}</p> : null}
        </div>

        {loading ? (
          <div className="featured__collection__products">
            {Array.from({ length: results || 8 }).map((_, index) => (
              <FeaturedProductSkeleton key={index} />
            ))}
          </div>
        ) : (
          <div className="featured__collection__products">
            {products.map((product) => (
              <FeaturedCollectionProduct
                product={product}
                key={product._id}
                category={false}
              />
            ))}
          </div>
        )}
      </div>
    </section>
  );
}

export default FeaturedCollection;
